import { useLayoutEffect } from 'react'
import useStore from '@src/store/common/global'

/**
 * 把 store.primaryHue 同步到 body 类名（如 body.hue-violet）。
 * blue 是默认色，不需要加类名。
 * 必须在 <BrowserRouter> 外侧调用，确保路由切换之间类名也持续存在。
 */
export const usePrimaryHueSync = () => {
	const hue = useStore((s) => s.primaryHue)
	useLayoutEffect(() => {
		const cls = document.body.classList
		cls.forEach((c) => {
			if (c.startsWith('hue-')) cls.remove(c)
		})
		if (hue !== 'blue') cls.add(`hue-${hue}`)
	}, [hue])
}
